import { owner } from './owner';
import { firstCoowner } from './firstCoowner';
import { secondCoowner } from './secondCoowner';

export const completeData = {
  ...owner,
  ...firstCoowner,
  ...secondCoowner,
};
